import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { QuoteAssistV2Service, SurveyFeedbackExistsResponse } from '../../services/quote-assist-v2.service';
 
@Component({
  selector: 'app-quote-assist-version',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './quote-assist-version.component.html',
  styleUrls: ['./quote-assist-version.component.scss']
})
export class QuoteAssistVersionComponent implements OnInit, OnDestroy {
  showPageDataLoading = false;
  private subscriptions: Subscription[] = [];
 
  queryParams = {
    rfqId: '',
    companyId: 0,
    rfqPartId: 0,
    contactId: 0,
    rfqStatusId: 0,
    isTrackingEnabled: 'false',
    integration: '',
    version: 'V1',
    rfqQuoteStatus: '',
    surveyDone: false,
    emailId: '',
  };
 
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private quoteAssistV2Service: QuoteAssistV2Service
  ) { }
 
  ngOnInit(): void {
    const paramsSub = this.route.queryParams.subscribe(params => {
      this.queryParams = {
        rfqId: params['rfqId'] || '',
        companyId: Number(params['companyId']) || 0,
        rfqPartId: Number(params['rfqPartId']) || 0,
        contactId: Number(params['contactId']) || 0,
        rfqStatusId: Number(params['rfqStatusId']) || 0,
        isTrackingEnabled: params['isTrackingEnabled'] || 'false',
        integration: params['integration'] || '',
        version: 'V1', // Default version, will be overridden by API call
        rfqQuoteStatus: params['rfqQuoteStatus'] || 'SUBMITTED',
        surveyDone: false, // Default value, will be overridden by API call
        emailId: params['emailId'] || '',
      };
      this.getRfqVersionFromApi();
    });
    this.subscriptions.push(paramsSub);
  }
 
  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
 
    private processQueryParams(params: any): void {
    this.queryParams = {
      rfqId: params['rfqId'] || '',
      companyId: Number(params['companyId']) || 0,
      rfqPartId: Number(params['rfqPartId']) || 0,
      contactId: Number(params['contactId']) || 0,
      rfqStatusId: Number(params['rfqStatusId']) || 0,
      isTrackingEnabled: params['isTrackingEnabled'] || 'false',
      integration: params['integration'] || '',
      version: 'V1', // Default version, will be overridden by API call
      rfqQuoteStatus: params['rfqQuoteStatus'] || 'SUBMITTED',
      surveyDone: params['surveyDone'] === 'true',
      emailId: params['emailId'] || '',
    };

    
  }
 
  private getRfqVersionFromApi(): void {
    if (!this.queryParams.rfqId) {
      this.queryParams.version ='V2';
      this.redirectBasedOnVersion();
      this.showPageDataLoading = false;
      return;
    }
    this.queryParams.version = 'V1';
    const apiSub = this.quoteAssistV2Service.getRfqVersion(this.queryParams.rfqId, this.queryParams.integration).subscribe({
      next: (response) => {       
        if (response.status && response.data) {
          this.queryParams.version = response.data === 1 ? 'V1' : 'V2';   
        } 
        this.redirectBasedOnVersion();
      },
      error: (error) => {
        console.error('Error fetching RFQ version:', error);
       
        this.redirectBasedOnVersion();
      }
    });
   
    this.subscriptions.push(apiSub);
  }
 
  private redirectBasedOnVersion(): void {
    // First check if survey feedback exists
    this.quoteAssistV2Service.checkSurveyFeedbackExists(this.queryParams.contactId).subscribe({
      next: (response) => {
        this.queryParams.surveyDone = response.data;
        this.performNavigation();
      },
      error: (error) => {
        console.error('Error checking survey feedback:', error);
        this.queryParams.surveyDone = false; // Default to false on error
        this.performNavigation();
      }
    });
  }

  private performNavigation(): void {
    const version = this.queryParams.version;
   
    // Validate version
    if (version !== 'V1' && version !== 'V2') {
      console.error('Invalid version specified:', version, 'Defaulting to V1');
      this.queryParams.version = 'V1';
    }

    const redirectParams = {
      rfqId: this.queryParams.rfqId,
      companyId: this.queryParams.companyId,
      rfqPartId: this.queryParams.rfqPartId,
      contactId: this.queryParams.contactId,
      rfqStatusId: this.queryParams.rfqStatusId,
      isTrackingEnabled: this.queryParams.isTrackingEnabled,
      integration: this.queryParams.integration,
      source: 'MFGDirect',
      rfqQuoteStatus: this.queryParams.rfqQuoteStatus,
      surveyDone: this.queryParams.surveyDone,
      emailId: this.queryParams.emailId,
    };

    let targetRoute: string;
    if (this.queryParams.version === 'V2') {
      targetRoute = '/quote-assist-v2';
    } else {
      if (this.queryParams.integration === 'MFG') {
        targetRoute = '/assist';
      } else {
        targetRoute = '/direct-quote-summary';
      }
    }
   
    this.router.navigate([targetRoute], {
      queryParams: redirectParams
    }).catch(error => {
      console.error('Navigation error:', error);
      this.showPageDataLoading = false;
    });
  }
}